(function () {
    'use strict';

    angular.module('app.filemanager', [
        'ngRoute',
        'app.directive'
    ]);
})();